module.exports = __webpack_public_path__ + "img/Banner4英文.68891425.png";